module.exports = __webpack_public_path__ + "files/c3c118ccc446cd93cb8f306836477da4.png";